import React, { Component } from "react";
import { connect } from 'react-redux';
import "./style.scss";
const firebase = require('firebase');

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      senderName: "",
      senderMail: "",
      senderPhone: "",
      senderCity: "",
      send: false,
      requiredError: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getSendLabel = this.getSendLabel.bind(this);
    this.getResetLabel = this.getResetLabel.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  handleSubmit(e) {
   
    e.preventDefault();
    if (typeof window !== "undefined") {
      if(this.state.message !== "") {
        const sendMailViaFB = async () => {
        
          try {
            const data = {
              message: this.state.message,
              mail: this.state.senderMail,
              name: this.state.senderName,
              phone: this.state.senderPhone,
              city: this.state.senderCity,
              spot: this.props.spot || ""
            }
            const req = await firebase.functions().httpsCallable('sendEmail')({...data});
            const res = await Promise.resolve(req);
           
          } catch (err) {
            console.log(err)
          }
        }
        sendMailViaFB()
        this.setState({
          message: "",
          senderName: "",
          senderMail: "",
          senderPhone: "",
          senderCity: "",
          send: true,
          requiredError: false
        })
      } else {
        this.setState({requiredError: true});
      }
    }
    
    };

    handleChange(event, key) {
      this.setState({[key]: event.target.value});
    }

    getSendLabel() {
      if(this.props.language === 'fi') {
        return 'Lähetä'
      } else if (this.props.language === 'sv' ) {
        return 'Skicka'
      } else {
        return 'Send'
      }
    }

    getResetLabel() {
      if(this.props.language === 'fi') {
        return 'Tyhjennä'
      } else if (this.props.language === 'sv' ) {
        return 'Klara'
      } else {
        return 'Reset'
      }
    }

    resetForm() {
      this.setState({
        message: "",
        senderName: "",
        senderMail: "",
        senderPhone: "",
        senderCity: "",
        send: false
      })
    }

  componentDidMount() {
    if (typeof window !== "undefined") {
    const config = {
      //apiKey: process.env.FIREBASE_API_KEY, // process.env.FIREBASE_API_KEY,
      projectId: 'kierratysinfo-firebase', 
    };
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
  }
   
  }
}

  render() {
    return (
      <div className="feedbackFormContainer">
        {this.props.heading === 'h1' ? 
          <h1>
            {this.props.language === 'fi' ? 'Lähetä palautetta' : null}
            {this.props.language === 'sv' ? 'Ge respons' : null}
            {this.props.language === 'en' ? 'Send feedback' : null}
          </h1>
        : 
          <h2>
            {this.props.language === 'fi' ? 'Lähetä palautetta' : null}
            {this.props.language === 'sv' ? 'Ge respons' : null}
            {this.props.language === 'en' ? 'Send feedback' : null}
          </h2>
        }
        <p>
        {this.props.language === 'fi' ? 'Täytä ainakin tähdellä merkityt kentät *' : null}
            {this.props.language === 'sv' ? 'Obligatorisk *' : null}
            {this.props.language === 'en' ? 'Mandatory field *' : null}
        </p>
        <form>
    
          <label htmlFor="message">
            {this.props.language === 'fi' ? 'Viesti *:' : null}
            {this.props.language === 'sv' ? 'Meddelande *:' : null}
            {this.props.language === 'en' ? 'Message *:' : null}
          
          </label><br />
          <textarea name="message" value={this.state.message} onChange={e => this.handleChange(e, 'message')}  /><br />
          <div className="grid-x inputGrid">
            <div className="cell medium-6">
              <label htmlFor="name">
                {this.props.language === 'fi' ? 'Nimi:' : null}
                {this.props.language === 'sv' ? 'Namn:' : null}
                {this.props.language === 'en' ? 'Name:' : null}
              </label><br />
              <input name="name" type="text" value={this.state.senderName} onChange={e => this.handleChange(e, 'senderName')} />
            </div>
            <div className="cell medium-6">
              <label htmlFor="email">
                {this.props.language === 'fi' ? 'Sähköposti:' : null}
                {this.props.language === 'sv' ? 'E-post:' : null}
                {this.props.language === 'en' ? 'Email:' : null}  
              </label><br />
              <input name="email" type="email" value={this.state.senderMail} onChange={e => this.handleChange(e, 'senderMail')} />
            </div>
            <div className="cell medium-6">
              <label htmlFor="phone">
                {this.props.language === 'fi' ? 'Puhelin:' : null}
                {this.props.language === 'sv' ? 'Telefonnummer:' : null}
                {this.props.language === 'en' ? 'Phone:' : null}    
              </label><br />
              <input name="phone" type="phone" value={this.state.senderPhone} onChange={e => this.handleChange(e, 'senderPhone')} />
            </div>
            <div className="cell medium-6">
              <label htmlFor="city">
                {this.props.language === 'fi' ? 'Paikkakunta:' : null}
                {this.props.language === 'sv' ? 'Ort:' : null}
                {this.props.language === 'en' ? 'District:' : null}    
              </label><br />
              <input name="city" type="phone" value={this.state.senderCity} onChange={e => this.handleChange(e, 'senderCity')} />
            </div>
          </div>
          <input name="submit" type="submit" value={this.getSendLabel()} onClick={(e) => {this.handleSubmit(e)} }/>
          <button className="resetBtn" type="button" onClick={this.resetForm}>{this.getResetLabel()}</button>
        </form>
        <br />
        {this.state.send && this.props.language === 'fi'   ? "Palautteesi on lähetetty": null}
        {this.state.send && this.props.language === 'sv'   ? "Tack för ditt meddelande": null}
        {this.state.send && this.props.language === 'en'   ? "Thank you for your feedback": null}

        {this.state.requiredError && this.props.language === 'fi' ? "Täytä ainakin vaaditut kentät": null}
        {this.state.requiredError && this.props.language === 'sv' ? "Fyll i obligatoriska fält": null}
        {this.state.requiredError && this.props.language === 'en' ? "Please fill mandatory fields": null}
      </div>
    )
  }
}


export default connect(state => ({
  language: state.language.language,
}), null)(Feedback);
